import axios from "axios";
import { API_URL } from "../../constants";

export default {
  getAllSubscriptionById: (id) => {
    return axios.get(`${API_URL.SUBCRIPTIONBYID}/${id}`, {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
  },
  getInvoice: (id) => {
    return axios.get(`${API_URL.INVOICE_PDF}/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      responseType: "blob",
    });
  },
  getSuscriptionDetail: (userUid) => {
    return axios.get(`${API_URL.SUSCRIPTION_DETAIL}/${userUid}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};
